/**
 * Action types for interpretare.policy addon
 * @module constants/ActionTypes
 */

export const UPLOAD_S3_FILE = 'UPLOAD_S3_FILE';
